import sanitizeHtml from "sanitize-html";
// see https://www.npmjs.com/package/sanitize-html for package default allowed tags
// only a tags are allowed to have attributes

export const cleanHtml = (dirtyHtml: string | null | undefined) => {
  if (dirtyHtml === null || dirtyHtml === undefined) {
    return dirtyHtml;
  }

  const cleanedHtml = sanitizeHtml(dirtyHtml, {
    allowedAttributes: {
      a: ["href", "name", "target"],
    },
    allowedClasses: {
      table: ["cq-sizeguidetable"],
    },
  });

  return cleanedHtml;
};
